{
  "version": 1,
  "asset_id": "69b8e312-3cca-419d-a4bf-629466ad93e5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/69b8e312-3cca-419d-a4bf-629466ad93e5/sleeve-ugi-normal-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/69b8e312-3cca-419d-a4bf-629466ad93e5/sleeve-ugi-normal-800.jpg",
  "original_filename": "sleeve-ugi-normal-800.jpg",
  "size": 133069,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T01:31:07Z"
}
